class FacetFiltersForm extends HTMLElement {
	constructor() {
		super()
		this.selectors = {
			container: '.f-facets__container',
			productGrid: '[data-products-grid]',
			productCount: '[data-product-count]',
			filtersForm: '[data-facet-form]',
			facetWrapper: '[data-facets-wrapper]',
			facetBlock: '.f-facets__block',
			sortBySelect: '[data-sortby-select]',
			sortByInput: '[name="sort_by"]',
			totalActiveInput: '[name="total_active_value"]',
			totalActiveCount: '[data-total-active-values]',
			collapsibleItems: ['collapsible-tab']
		}
	}

	connectedCallback() {
		this.domNodes = queryDomNodes(this.selectors, this.section)
		this.setData()
		this.debouncedOnSubmit = debounce(evt => this.onSubmitHandler(evt), 500)
		this.domNodes.filtersForm?.addEventListener('input', (evt) => {
			this.loading.start()
			this.debouncedOnSubmit(evt)
		})
		window.addEventListener('popstate', this.onHistoryChange)
	}

	disconnectedCallback() {
		window.removeEventListener('popstate', this.onHistoryChange)
	}

	setData = () => {
		this.section = document.querySelector('#ProductGridContainer')
		this.sectionId = this.section.dataset.sectionId
		this.filterData = []
		this.searchParamsInitial = window.location.search.slice(1)
		this.searchParamsPrev = window.location.search.slice(1)
		this.loading = new window.FoxTheme.AnimateLoading(document.body, {overlay: document.querySelector(this.selectors.productGrid)})
		this.container = this.section.querySelector(this.selectors.container)
		this.collapsible = this.container && this.container.dataset.collapsible === 'true'
	}

	renderPage = (searchParams, event, updateURLHash = true) => {
		this.searchParamsPrev = searchParams
		const sections = this.getSections()

		sections.forEach((section) => {
			const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`
			const filterDataUrl = element => element.url === url

			this.filterData.some(filterDataUrl) ?
				this.renderSectionFromCache(filterDataUrl, event) :
				this.renderSectionFromFetch(url, event)
		})

		window.scroll({
			top: this.section.offsetTop - 100,
			left: 0,
			behavior: 'smooth'
		})
		this.loading.finish()

		if (updateURLHash) this.updateURLHash(searchParams)
	}

	renderSectionFromFetch = (url, event) => {
		fetch(url)
			.then(response => response.text())
			.then((responseText) => {
				const html = responseText
				this.filterData = [...this.filterData, {html, url}]
				this.renderFilters(html, event)
				this.renderProductGridContainer(html)
				this.renderProductCount(html)
			})
	}

	renderSectionFromCache = (filterDataUrl, event) => {
		const html = this.filterData.find(filterDataUrl).html
		this.renderFilters(html, event)
		this.renderProductGridContainer(html)
		this.renderProductCount(html)
	}

	renderProductGridContainer = (html) => {
		const parsedHTML = new DOMParser().parseFromString(html, 'text/html')
		document.querySelector('[data-product-container]').innerHTML = parsedHTML.querySelector('[data-product-container]').innerHTML
		this.loading = new window.FoxTheme.AnimateLoading(document.body, {overlay: document.querySelector(this.selectors.productGrid)})
	}

	renderProductCount = (html) => {
		const parsedHTML = new DOMParser().parseFromString(html, 'text/html')
		const count = parsedHTML.querySelector(this.selectors.productCount).innerHTML
		this.domNodes.productCount.innerHTML = count
	}

	renderFilters = (html, event) => {
		const parsedHTML = new DOMParser().parseFromString(html, 'text/html')

		const facetDetailsElements =
			parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter')
		const matchesIndex = (element) => {
			const facetBlock = event ? event.target.closest(this.selectors.facetBlock) : undefined
			return facetBlock ? element.dataset.index === facetBlock.dataset.index : false
		}
		const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element))
		const countsToRender = Array.from(facetDetailsElements).find(matchesIndex)

		facetsToRender.forEach((element) => {
			const target = document.querySelector(`.f-facets__block[data-index="${element.dataset.index}"]`)
			if (!target) return
			target.textContent = ''
			const child = element.querySelector('collapsible-tab')
			target.appendChild(child)
		})

		this.renderActiveFacets(parsedHTML)

		// if (countsToRender) this.renderCounts(countsToRender, event.target.closest(this.selectors.facetBlock))
	}

	renderActiveFacets = (html) => {
		const activeFacetElementSelectors = ['.active-facets']

		activeFacetElementSelectors.forEach((selector) => {
			const activeFacetsElement = html.querySelector(selector)
			if (!activeFacetsElement) return
			document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML
		})
	}

	renderCounts = (source, target) => {
		const targetElement = target.querySelector('.facets__selected')
		const sourceElement = source.querySelector('.facets__selected')

		if (sourceElement && targetElement) {
			target.querySelector('.facets__selected').outerHTML = source.querySelector('.f-facets__selected').outerHTML
		}
	}

	updateURLHash = (searchParams) => {
		history.pushState({searchParams}, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`)
	}

	getSections = () => {
		return [
			{
				section: this.sectionId
			}
		]
	}

	onSubmitHandler = (event) => {
		event.preventDefault()
		const formData = new FormData(event.target.closest('form'))
		const searchParams = new URLSearchParams(formData).toString()
		this.renderPage(searchParams, event)
	}

	onActiveFilterClick = (event) => {
		event.preventDefault()
		const url = event.currentTarget.href.indexOf('?') === -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1)
		this.renderPage(url)
	}

	onHistoryChange = (event) => {
		const searchParams = event.state ? event.state.searchParams : this.searchParamsInitial
		if (searchParams === this.searchParamsPrev) return
		this.renderPage(searchParams, null, false)
	}
}

customElements.define('facet-filters-form', FacetFiltersForm)

class PriceRange extends HTMLElement {
	selectors = {
		inputs: ['input[type="number"]'],
		ranges: ['input[type="range"]'],
		minRange: '[data-type="min-range"]',
		maxRange: '[data-type="max-range"]',
		minInput: '[data-type="min-input"]',
		maxInput: '[data-type="max-input"]'
	}

	constructor() {
		super()
		this.domNodes = queryDomNodes(this.selectors, this)
		this.priceGap = parseInt(this.dataset.priceGap)
		this.priceMax = parseInt(this.dataset.priceMax)

		this.domNodes.inputs.forEach(el => el.addEventListener('change', this.onInputChange.bind(this)))
		this.domNodes.ranges.forEach(el => el.addEventListener('input', this.onSliderChange.bind(this)))

		this.setMinAndMaxValues()
	}

	onSliderChange(event) {
		const input = event.currentTarget
		const type = input.dataset.type
		const value = Number(input.value)
		const {minInput, maxInput, minRange, maxRange} = this.domNodes
		if (type === 'min-range') {
			if ((maxRange.value - input.value) >= this.priceGap) {
				minInput.value = input.value
			} else {
				input.value = maxRange.value - this.priceGap
			}
		}
		if (type === 'max-range') {
			if ((input.value - minRange.value) >= this.priceGap) {
				maxInput.value = input.value
			} else {
				input.value = Number(minRange.value) + Number(this.priceGap)
			}
		}
		this.style.setProperty('--price-min', 100 * minRange.value / this.priceMax + '%')
		this.style.setProperty('--price-max', 100 * maxRange.value / this.priceMax + '%')
	}

	onInputChange(event) {
		this.adjustToValidValues(event.currentTarget)
		this.setMinAndMaxValues()
	}

	setMinAndMaxValues() {
		const {minInput, maxInput} = this.domNodes
		if (maxInput.value) minInput.setAttribute('max', Number(maxInput.value) - this.priceGap)
		if (minInput.value) maxInput.setAttribute('min', Number(minInput.value) + this.priceGap)
		if (minInput.value === '') maxInput.setAttribute('min', 0)
		if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'))
	}

	adjustToValidValues(input) {
		const value = Number(input.value)
		const min = Number(input.getAttribute('min'))
		const max = Number(input.getAttribute('max'))

		if (value < min) input.value = min
		if (value > max) input.value = max
	}
}

customElements.define('price-range', PriceRange)

class FacetRemove extends HTMLElement {
	constructor() {
		super()
		this.querySelector('a').addEventListener('click', (e) => {
			e.preventDefault()
			const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form')
			form.onActiveFilterClick(e)
		})
	}
}

customElements.define('facet-remove', FacetRemove)

class ApplyButton extends HTMLElement {
	constructor() {
		super()
		const drawer = this.closest('drawer-component')
		this.querySelector('button').addEventListener('click', e => {
			e.preventDefault()
			drawer?.closeDrawer(false)
		})
	}
}

customElements.define('facet-apply', ApplyButton)

class SortBySelect extends HTMLElement {
	constructor() {
		super()
		this.select = this.querySelector('select')
		this.sortByInput = document.querySelector('[name="sort_by"]')
		this.filtersForm = document.querySelector('[data-facet-form]')

		this.select.addEventListener('change', this.handleChange.bind(this))
	}
	handleChange(event) {
		this.sortByInput.value = event.target.value
		this.filtersForm.dispatchEvent(new Event('input'))
	}
}

customElements.define('sortby-select', SortBySelect)
